"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ServiceProvider = /** @class */ (function () {
    function ServiceProvider(injector) {
        this.injector = injector;
        ServiceProvider.injector = injector;
    }
    ServiceProvider.provideIfNotProvided = function (service, defaultService) {
        function factory() {
            var deps = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                deps[_i] = arguments[_i];
            }
            try {
                return ServiceProvider.injector.get(service);
            }
            catch (_a) { }
            return defaultService ? new (defaultService.bind.apply(defaultService, [void 0].concat(deps)))() : new (service.bind.apply(service, [void 0].concat(deps)))();
        }
        return factory;
    };
    ServiceProvider.injector = undefined;
    ServiceProvider.decorators = [
        { type: core_1.NgModule },
    ];
    /** @nocollapse */
    ServiceProvider.ctorParameters = function () { return [
        { type: core_1.Injector, },
    ]; };
    return ServiceProvider;
}());
exports.ServiceProvider = ServiceProvider;
//# sourceMappingURL=service.provider.js.map